import { render, staticRenderFns } from "./vrmapss.vue?vue&type=template&id=12010068&"
import script from "./vrmapss.vue?vue&type=script&lang=js&"
export * from "./vrmapss.vue?vue&type=script&lang=js&"
import style0 from "./vrmapss.vue?vue&type=style&index=0&id=12010068&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports